/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Include_Vchip_InfoInputs */

const en_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include V-Chip Information`)
};

const fr_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure les informations sur la puce V`)
};

const de_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V-Chip-Informationen einbeziehen`)
};

const it_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi informazioni sul V-Chip`)
};

const ru_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите информацию о V-чипе.`)
};

const es_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir información del V-Chip`)
};

const zh_cn2_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含 V-Chip 信息`)
};

const ja_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vチップ情報を含める`)
};

const hi_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वी-चिप की जानकारी शामिल करें`)
};

const pt_pt2_subtitle_export_include_vchip_info = /** @type {(inputs: Subtitle_Export_Include_Vchip_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir informações do V-Chip`)
};

/**
* | output |
* | --- |
* | "Include V-Chip Information" |
*
* @param {Subtitle_Export_Include_Vchip_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_include_vchip_info = /** @type {((inputs?: Subtitle_Export_Include_Vchip_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Include_Vchip_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_include_vchip_info(inputs)
	if (locale === "de") return de_subtitle_export_include_vchip_info(inputs)
	if (locale === "it") return it_subtitle_export_include_vchip_info(inputs)
	if (locale === "ru") return ru_subtitle_export_include_vchip_info(inputs)
	if (locale === "es") return es_subtitle_export_include_vchip_info(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_include_vchip_info(inputs)
	if (locale === "ja") return ja_subtitle_export_include_vchip_info(inputs)
	if (locale === "hi") return hi_subtitle_export_include_vchip_info(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_include_vchip_info(inputs)
	return en_subtitle_export_include_vchip_info(inputs)
});